/* eslint-disable no-multi-str */
import React from 'react';
import { Typography } from '@sm/wds-react';
import { T, defineMessages } from '@sm/intl';

import './five-hundred-error.scss';

const COPY = defineMessages({
  SORRY_MESSAGE: {
    id: 'FiveHundredError.sorryMessage',
    defaultMessage: "We're sorry",
    description: '[Type: Label][Vis.: med] - We are sorry message'
  },
  SOMETHING_WRONG: {
    id: 'FiveHundredError.somethingWentWrong',
    defaultMessage: 'Something went wrong.',
    description: '[Type: Label][Vis.: med] - something went wrong subtitle'
  },
  FIVE_HUNDRED_MESSAGE: {
    id: 'FiveHundredError.fiveHundredMessage',
    defaultMessage:
      "Sorry if you lost your place - we're working hard to get things up\
    and running again. Thanks for your patience!",
    description: '[Type: Label][Vis.: med] - Five Hundred Error Message'
  },
  HOME: {
    id: 'FiveHundredError.home',
    defaultMessage: 'Home',
    description:
      '[Type: Label][Vis.: med] - Home link in Five Hundred Error Message'
  },
  SITEMAP: {
    id: 'FiveHundredError.sitemap',
    defaultMessage: 'Sitemap',
    description:
      '[Type: Label][Vis.: med] - Sitemap link in Five Hundred Error Message'
  },
  HELP_CENTER: {
    id: 'FiveHundredError.helpCenter',
    defaultMessage: 'Help Center',
    description:
      '[Type: Label][Vis.: med] - Help Center link in Five Hundred Error Message'
  },
  TEMPLATES: {
    id: 'FiveHundredError.templates',
    defaultMessage: 'Templates',
    description:
      '[Type: Label][Vis.: med] - Templates link in Five Hundred Error Message'
  },
  LEARN_MORE: {
    id: 'FiveHundredError.learnMore',
    defaultMessage: 'Learn More',
    description:
      '[Type: Label][Vis.: med] - Learn More link in Five Hundred Error Message'
  }
});

const FiveHundredError = () => (
  <div className="sm-five-hundred-error" data-testid="FiveHundredError">
    <div className="sm-five-hundred-error__message-wrapper">
      <Typography variant="pageTitle">
        <T desc={COPY.SORRY_MESSAGE} />
      </Typography>
      <div className="sm-five-hundred-error__message-container">
        <Typography variant="sectionTitle">
          <T desc={COPY.SOMETHING_WRONG} />
        </Typography>
        <Typography component="div" variant="body" className="wds-p-1">
          <p>
            <T desc={COPY.FIVE_HUNDRED_MESSAGE} />
          </p>
        </Typography>
        <div className="sm-five-hundred-error__links-container">
          <ul className="sm-five-hundred-error__links-list">
            <li className="sm-five-hundred-error__links-list-item">
              <a href="/">
                <T desc={COPY.HOME} />
              </a>
            </li>
            <li className="sm-five-hundred-error__links-list-item">
              <a href="/mp/sitemap/">
                <T desc={COPY.HOME} />
              </a>
            </li>
            <li className="sm-five-hundred-error__links-list-item">
              <a href="https://help.surveymonkey.com/">
                <T desc={COPY.HELP_CENTER} />
              </a>
            </li>
            <li className="sm-five-hundred-error__links-list-item">
              <a href="/mp/survey-templates/">
                <T desc={COPY.TEMPLATES} />
              </a>
            </li>
            <li className="sm-five-hundred-error__links-list-item">
              <a href="/mp/take-a-tour/">
                <T desc={COPY.LEARN_MORE} />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
);

export default FiveHundredError;
